import BaseApi from "./BaseApi";

export default class OptInService {
    static put(command) {
        return BaseApi.patch(`optIn/v1`, command);
    }

    static putInscricao(command) {
        return BaseApi.put(`optIn/v1/inscricao`, command);
    }

    static get(ru) {
        return BaseApi.get(`optIn/v1/${ru}`);
    }

    static getInscricoes(ru) {
        return BaseApi.get(`optIn/v1/${ru}/inscricoes`);
    }
}